import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import Tooltip from 'components/misc/Tooltip'
import Header from 'components/typography/Header'
import { fetchMoreLikeThis } from 'store/report/actions'
import Result from 'components/search/Result'
import Link from 'components/misc/Link'
import CircleSpinner from 'components/misc/CircleSpinner'
import Notification from '../misc/Notification'

import styles from './styles/EmptyCitations.css'

const Results = ({ results, loading }) => {
  if (loading) {
    return <CircleSpinner className={styles.spinner} />
  }

  return (
    <>
      {
        results.map(result => <Result key={result.doi} className={styles.result} result={result} />)
      }
    </>
  )
}

const EmptyCitations = ({ title, abstract, doi }) => {
  const dispatch = useDispatch()
  const allResults = useSelector(({ report }) => report.moreLikeThisResults || [])
  // filter out recommendations with the same title.
  const results = allResults.filter(result => result.title !== title)
  const loading = useSelector(({ report }) => report.moreLikeThisLoading)

  useEffect(() => {
    if ((!results || results?.length === 0) && (abstract || title)) {
      dispatch(fetchMoreLikeThis({ like: (abstract || title).slice(0, 1000) }))
    }
  }, [abstract, title])

  return (
    <div className={styles.emptyCitationsContainer}>
      <div className={styles.emptyCitationsHeader}>
        <Header level={4}>This publication either has no citations yet, or we are still processing them</Header>
        <Tooltip
          className={styles.countDisclaimer}
          refClassName={styles.noCitesDisclaimerIconWrapper}
          header='Not what you expected?'
          content="In order to extract citation statements, we need to process full-text articles whereas other citation indices do not. While this means our numbers might be a bit lower, we're adding millions of citation statements to the database each day!"
        >
          <i className={styles.countDisclaimerIcon} />
        </Tooltip>
      </div>
      <div className={styles.notificationContainer}> Set email alert for when this publication receives citations?
        <Notification
          source={doi}
          name={title || 'untitled'}
          category='paper'
          className={styles.notification}
          checkbox
        />
      </div>
      <div>
        <div className={styles.resultsLayout}>
          <Header level={4} className={styles.moreLikeThisHeader}>See others like this or <Link blue underline to={`/search?page=1&q=${encodeURIComponent(title)}`}>search for similar articles</Link></Header>
          <div className={styles.results}>
            <Results results={results} loading={loading} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmptyCitations
